import { Component, OnInit } from '@angular/core';
import { DateRangeInterval } from '@app/core/components/date-range/date-range.component';
import { Grid } from '@app/core/components/grid/grid.model';
import { GridOptions, GridRow } from '@app/core/components/grid/grid.types';
import { DataTaskService } from '@app/core/services/data-task.service';
import { TypeaheadService } from '@app/services/typeahead.service';
import { BusinesscoItem, LogisticService, StockplaceItem } from '@app/services/logistic.service';
import { Item } from '../../../core/components/listbox/listbox.component';
import { RowSelectedEvent } from '@ag-grid-community/core';

@Component({
    selector: 'tt-prognosis-purchase-overview',
    templateUrl: './prognosis-purchase-overview.component.html',
    styleUrls: ['./prognosis-purchase-overview.component.css'],
})
export class PrognosisPurchaseOverviewComponent implements OnInit {
    public get?: PrognosisPurchaseOverviewGet;

    public companies: BusinesscoItem[] = [];

    public stockplaces: StockplaceItem[] = [];

    public overviewGrid?: GridOptions;

    public detailGrid?: GridOptions;

    public selectedRow?: GridRow;

    constructor(private datatask: DataTaskService, private logistic: LogisticService, private typeahead: TypeaheadService) {}

    public searchSupplier = () => {
        return this.typeahead.searchCustomer({ cust_name: (this.get?.supplier_name ?? '') as string, custtype: 'S' });
    };

    public onSupplierSelected(event?: Item) {
        if (!!this.get) {
            this.get.supplier_no = (event?.item_id ?? '0') as string;
            this.get.supplier_name = (event?.item_name ?? '') as string;
            this.readOverviewGrid();
        }
    }

    public onOverviewGridReady() {
        this.overviewGrid?.gridfunc?.selectRow(0);
    }

    public onPrognosisSelected(event: RowSelectedEvent) {
        if (event.node.isSelected()) {
            if ('prodchoice_keyno' in event.data) {
                this.selectedRow = event.data;
            } else {
                delete this.selectedRow;
            }

            this.readDetailsGrid();
        }
    }

    public async onWeeksPrPeriodChanged() {
        await this.readOverviewGrid();
        this.loadGet();
    }

    public readOverviewGrid() {
        return this.overviewGrid?.gridfunc?.read();
    }

    public readDetailsGrid() {
        if (!this.selectedRow || !('prodchoice_keyno' in this.selectedRow)) return;
        if (!this.detailGrid) {
            this.createDetailsGrid();
        } else {
            this.detailGrid.gridfunc?.read();
        }
    }

    private createOverviewGrid() {
        if (!!this.get) {
            this.overviewGrid = new Grid().setRememberId('prognosispurchase_overview.grid').setLoadDataFunction({ method: 3750, parameters: () => this.get });
        }
    }

    private createDetailsGrid() {
        if (!!this.get && !!this.selectedRow) {
            this.detailGrid = new Grid().setRememberId('prognosispurchase_purchase.grid').setLoadDataFunction({ method: 3755, parameters: () => ({ ...this.get, ...this.selectedRow }) });
        }
    }

    private async loadCompanies() {
        this.companies = await this.logistic.getCompanies('0');
    }

    public async loadStockplaces() {
        this.stockplaces = await this.logistic.getStockplaces({ businessco_no: (this.get?.businessco_no ?? '0') as string, add_all: '0' });
    }

    private async loadGet() {
        this.get = (await this.datatask.Post(3749))[0];
    }

    private async init() {
        this.loadCompanies();
        await this.loadGet();
        this.loadStockplaces();
        this.createOverviewGrid();
    }

    ngOnInit() {
        this.init();
    }
}

interface PrognosisPurchaseOverviewGet {
    heading: string;
    businessco_no: number | string;
    stockplace_id: string;
    date_fom: string;
    date_tom: string;
    date_interval: DateRangeInterval;
    supplier_no: string;
    supplier_name: string;
    weeks_pr_period: number | string;
}
